import { Box, Link, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { getSources } from "../utils/constants/data-sources.js";

const linkProps = { target: "_blank", rel: "noopener noreferrer", color: "inherit" };

// One caption line per provider: "Data source: <provider> (License: <name>) <note>".
// Entries come from the registry (organization + optional collection) unless `sources` overrides them.
const DataSourceNote = ({ organization, collection, sources }) => {
	const { t } = useTranslation();
	const entries = sources ?? getSources(organization, collection);

	if (entries.length === 0) return null;

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: "2px", width: "100%" }}>
			{entries.map(({ provider, url, license, note }) => (
				<Typography key={provider} variant="caption" component="p" sx={{ m: 0, overflowWrap: "anywhere" }}>
					{t("legal.dataSource")}{" "}
					{url ? <Link href={url} {...linkProps}>{provider}</Link> : provider}
					{license && (
						<>
							{" · "}
							{t("legal.dataLicense")}{" "}
							<Link href={license.url} {...linkProps}>{license.name}</Link>
						</>
					)}
					{note && ` · ${note}`}
				</Typography>
			))}
		</Box>
	);
};

export default memo(DataSourceNote);
